import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class Ques extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: null
    };

    this.handleRespond = this.handleRespond.bind(this)
  }

  componentDidMount() {

  }  

  handleRespond(e, n){
    this.setState({ selected: n });
    this.props.onRespond(e);
  }

  render() {

    let alts = [
      <div className={'btn-group btn-group-toggle ' + ((this.state.selected == 1) ? 'selected' : '')} key="alt-1">
        <label className="btn btn-grey btn-lg">
          <input type="radio" autoComplete="off" name={'question-' + this.props.item._id} data-qid={this.props.item._id} value="100" onClick={ e => this.handleRespond(e,1) } /> Si</label>
      </div>,
      <div className={'btn-group btn-group-toggle ' + ((this.state.selected == 2) ? 'selected' : '')} key="alt-2">
        <label className="btn btn-grey btn-lg">
          <input type="radio" autoComplete="off" name={'question-' + this.props.item._id} data-qid={this.props.item._id} value="70" onClick={ e => this.handleRespond(e,2) } /> A veces</label>
      </div>,
      <div className={'btn-group btn-group-toggle ' + ((this.state.selected == 3) ? 'selected' : '')} key="alt-3">
        <label className="btn btn-grey btn-lg">
          <input type="radio" autoComplete="off" name={'question-' + this.props.item._id} data-qid={this.props.item._id} value="50" onClick={ e => this.handleRespond(e,3) } /> Neutro</label>
      </div>,
      <div className={'btn-group btn-group-toggle ' + ((this.state.selected == 4) ? 'selected' : '')} key="alt-4">
        <label className="btn btn-grey btn-lg">
          <input type="radio" autoComplete="off" name={'question-' + this.props.item._id} data-qid={this.props.item._id} value="30" onClick={ e => this.handleRespond(e,4) } /> Poco</label>
      </div>,
      <div className={'btn-group btn-group-toggle ' + ((this.state.selected == 5) ? 'selected' : '')} key="alt-5">
        <label className="btn btn-grey btn-lg">
          <input type="radio" autoComplete="off" name={'question-' + this.props.item._id} data-qid={this.props.item._id} value="0" onClick={ e => this.handleRespond(e,5) } /> No</label>
      </div>
    ];
    
    return (
    	<div key={this.props.item._id} className="text-center margin-top-10 margin-bot-80">
          <h5 className="text-center"> { this.props.item.question }</h5>

          <div className="btn-group" role="group" style={{ display: 'block', margin:'20px auto 0 auto' }}>
            {alts}
          </div>

        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/test/Ques.jsx